import "./styles/index.scss";

import { RouterProvider } from "react-router-dom";

import { ErrorBoundary, Spinner } from "@app/components";
import { TelemetryTracingProvider } from "@app/contexts";
import { router } from "@app/routes";
import { StylesReset } from "@app/styles";
import { getEnvConfig } from "@app/utils";
import { FlagProvider } from "@unleash/proxy-client-react";
import { UserStateProvider } from "api/lib";
import { PusherProvider, ThemeProvider } from "mystique/lib";

export const App = () => {
  const env = getEnvConfig();
  const unleashConfig = {
    url: env.UNLEASH_URL,
    clientKey: env.UNLEASH_TOKEN,
    refreshInterval: 1800,
    appName: "honeycomb",
    environment: env.UNLEASH_ENV,
  };

  return (
    <TelemetryTracingProvider
      apiKey={env.OTEL_KEY}
      exporterUrl={env.OTEL_EXPORT_URL}
      serviceName={env.OTEL_SERVICE_NAME}
    >
      <ErrorBoundary>
        <StylesReset />
        <ThemeProvider>
          <UserStateProvider>
            <FlagProvider config={unleashConfig}>
              <PusherProvider>
                <RouterProvider router={router} fallbackElement={<Spinner />} />
              </PusherProvider>
            </FlagProvider>
          </UserStateProvider>
        </ThemeProvider>
      </ErrorBoundary>
    </TelemetryTracingProvider>
  );
};
